/*eslint no-unused-vars: "off"*/
import { getPageAnalytics, getCartAnalytics, safeBuildEventObj, getTransactionAnalytics } from '@ynap/analytics'

export function _createAnalyticsEvent(props) {
    const {
        lineItems,
        analytics,
        locale,
        x_exchangeRate,
        saleOrderFlag,
        pageConfigs = {},
        allowEmpty,
        useIdentifier = false,
    } = props

    if (lineItems.length < 1 && !allowEmpty) return {}

    const cart = getCartAnalytics({ ...props, saleOrderFlag, useIdentifier })
    delete cart.cartID

    const pageAnalytics = getPageAnalytics({
        ...analytics,
        ...locale,
        ...pageConfigs,
        extraAttributes: {
            exchangeRateGBP: x_exchangeRate?.exchangeRateGBP || 1,
            exchangeRateEUR: x_exchangeRate?.exchangeRateEUR || 1,
            exchangeRateGBPDaily: x_exchangeRate?.exchangeRateGBPDaily || 1,
            exchangeRateEURDaily: x_exchangeRate?.exchangeRateEURDaily || 1,
        },
    })

    return {
        transaction: getTransactionAnalytics(props),
        ...pageAnalytics,
        cart
    }
}

export default (args) => safeBuildEventObj(_createAnalyticsEvent, args)
